import { ChevronLeft, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Grid, Grid2, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';

class LeadsReportMobile extends Component {
    state = {  } 
    render() { 
        return (
        <Box>
            <NavbarMobile title={"Leads Report"} {...this.props} />
            <Box sx={{padding: "10px"}}>
                <Filter {...this.props} />
                {
                    this.props.contactLeads.map(leadGroup => {
                        return (
                            <Accordion key={leadGroup.salesId}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">{leadGroup.salesName}</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.leads.length} leads
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">Respon &gt; 1 menit</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.totalHigher60} leads
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">Respon &lt; 1 menit</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.totalUnder60} leads
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">PAID</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.labelPaid} leads
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">UNPAID</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.labelUnpaid} leads
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">DP</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.labelDp} leads
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">PENDING</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.labelPending} leads
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">CANCEL</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.labelCancel} leads
                                        </Grid>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        );
                    })
                }
            </Box>
        </Box>
        );
    }
}
 
export default LeadsReportMobile;